/**
 *
 * RegionSelector
 *
 */

import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  makeSelectShowRegionSelector,
  makeSelectClientDetails,
  makeSelectRegion,
} from 'containers/Main/selectors';
import { setRegion, showRegionSelector } from 'containers/Main/actions';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import { useQuery } from 'react-query';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import axios from 'axios';
import Regions from './Regions';
import getRegionsByClient from './getRegionsByClient';
import { getCountryRegion } from './utils';

const useStyles = makeStyles(theme => ({
  root: {
    background: '#FFFFFF',
    position: 'relative',
    maxWidth: 635,
    margin: '0 auto',
    top: '15%',
    padding: 49,
    [theme.breakpoints.down('xs')]: {
      margin: '0 5%',
      padding: 40,
    },
  },
  title: {
    ...theme.typography.h4,
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.h6,
    },
  },
}));

function RegionSelector() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [processing, setProcessing] = useState(false);
  const clientDetails = useSelector(makeSelectClientDetails());
  const showingRegionSelector = useSelector(makeSelectShowRegionSelector());
  const region = useSelector(makeSelectRegion());
  const clientId = _get(clientDetails, 'sys.id');
  const slug = _get(clientDetails, 'slug');
  const { data, isFetching } = useQuery(
    clientId && ['regions', clientId],
    getRegionsByClient,
  );

  useEffect(() => {
    async function fetchLocationInfo() {
      let lookupData = 'US';
      try {
        lookupData = await axios.get('https://extreme-ip-lookup.com/json');
      } catch (error) {
        lookupData = 'US';
      }

      const countryRegion = getCountryRegion(lookupData);
      if (countryRegion) {
        let regionSlug = `${slug}-${countryRegion.toLowerCase()}`;
        const slugIsInRegions = data.some(
          el => _get(el, 'fields.slug') === regionSlug,
        );
        regionSlug = slugIsInRegions ? regionSlug : `${slug}-us`;
        setProcessing(false);
        dispatch(setRegion(regionSlug));
        dispatch(showRegionSelector(false));
      }
    }
    if (slug && !region && !_isEmpty(data)) {
      setProcessing(true);
      fetchLocationInfo();
    }
  }, [clientDetails, data]);

  if (isFetching || _isEmpty(data) || processing) return null;
  return (
    <Modal open={showingRegionSelector}>
      <div className={classes.root}>
        <Typography className={classes.title} align="center">
          Please Choose Your Location
        </Typography>
        <Regions data={data} />
      </div>
    </Modal>
  );
}

RegionSelector.propTypes = {};

export default React.memo(RegionSelector);
